import React, { FC } from "react";
import NcdcRequestProgress from "./NcdcRequestProgress";
import classNames from "classnames";
import {useForm} from "react-hook-form";

type Props = {
    page: number;
    getPage: (seq: number) => void;
    getData: (data: any) => void;
}

const NcdcRequestWork: FC<Props> = ({page, getPage, getData}) => {
    const goToPrev = () => {
        window.scrollTo(0, 0);
        getPage(page - 1);
    }

    const goToNext = () => {
        window.scrollTo(0, 0);
        getPage(page + 1);
    }

    const { register, handleSubmit } = useForm();
    const onSubmit = (data: any) => {
        window.scrollTo(0, 0);
        getPage(page + 1);
        getData(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>

        <div className={classNames('ncdc-request-form-wrapper', {'no-show': page !== 3})}>
            <div className={'ncdc-request-form'}>
                <div className={'common-form-header-wrapper'}>
                    <span className={'common-form-header-title'}>데이터 신청</span>
                    <div className={'common-form-header-circle'} />
                </div>
                <NcdcRequestProgress seq={page - 1} />
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                연구유형
                            </div>
                            <div className={'common-form-table-header-alert'}>
                                * 필수사항입니다.
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구유형
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'}  {...register("resType")} />
                                </label>
                                <label className={'last'}>
                                    <span className={'common-form-input-label'}>
                                        연구DB
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                연구과제 정보
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구명
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text xl'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구기관
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text xl'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구주제[대상질환]
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text xl'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구목적
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text xl'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구내용
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <textarea className={'common-form-input-textarea'} placeholder={'500자 이내'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구방법
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <textarea className={'common-form-input-textarea'} placeholder={'500자 이내'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        기대효과/활용방안
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <textarea className={'common-form-input-textarea'} placeholder={'500자 이내'} />
                                </label>
                                <label className={'last'}>
                                    <span className={'common-form-input-label'}>
                                        연구비지원 출처
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text xl'} />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-button-wrapper'}>
                    <div>
                        <button className={'common-button light'} onClick={goToPrev}>이전</button>
                    </div>
                    <div>
                        <button className={'common-button light'}>임시저장</button>
                        <button className={'common-button primary ml-10'} type='submit'>다음</button>
                    </div>
                </div>
            </div>
        </div>
        </form>
    );
}

export default NcdcRequestWork;
